import { VIZE_BELGELERI } from './metin/vize-belgeleri';
/** Display only: the original product code and provider fee mapping remain unchanged. */
export function vizeUrunAdi(code: string, fallback: string): string {
  return VIZE_BELGELERI.urunler[code as keyof typeof VIZE_BELGELERI.urunler] ?? fallback;
}
